module.exports = __webpack_public_path__ + "img/kefu.19485b23.jpg";